export default {
  close: {
    id: 'bo_seller_customer_reviews_filters_mobile_close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'bo_seller_customer_reviews_filters_mobile_title',
    defaultMessage: 'Filters',
  },
}
